import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import TargetForm from '../../components/Forms/TargetForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { useTarget } from '../../hooks/CompanyConfiguration/useTarget'
import { ROUTES } from '../../shared/constants'
import Target from '../Target'

export default function AddTarget({ currentTarget }) {
  // const classes = useStyles()
  const [targetForm, setTargetForm] = useState({
    name: '',
    validity: '',
    store: '',
    from: new Date(),
    to: new Date(),
    noOfPeriod: 0,
    amount: [],
    singleAmount: '',
    targetCode: '',
  })

  useEffect(() => {
    if (currentTarget) {
      setTargetForm({
        ...targetForm,
        name: currentTarget.name,
        validity: currentTarget.targetDuration[0].targetValidity,
        store: currentTarget.store && currentTarget.store._id,
        noOfPeriod: currentTarget.noOfPeriod,
        targetCode: currentTarget.targetCode,
        amount: currentTarget.targetDuration.map((val) => val.targetAmount),
        from: new Date(currentTarget.targetDuration[0].targetFrom).toISOString(),
      })
    }
  }, [currentTarget])

  const { addTarget, updateTarget, loading } = useTarget()
  console.warn('LOADING @ 41 ', loading)
  const handleTarget = () => {
    if (currentTarget) {
      updateTarget({
        ...targetForm,
        targetId: currentTarget._id,
        targetValidity: targetForm.validity,
        targetFrom: targetForm.from,
        amount: targetForm.validity === 'CUSTOM' ? [parseInt(targetForm.singleAmount)] : targetForm.amount,
      })
    } else {
      addTarget({
        ...targetForm,
        amount: targetForm.validity === 'CUSTOM' ? [parseInt(targetForm.singleAmount)] : targetForm.amount,
        targetValidity: targetForm.validity,
        targetFrom: targetForm.from,
      })
    }
  }

  return (
    <Layout heading="Target" heading2={currentTarget ? 'Edit' : 'Add'} url1={ROUTES.ALL_TARGETS} none>
      <HeaderTabLayout
        heading={`${currentTarget ? 'Edit' : 'Add'} Target`}
        content={<TargetForm form={targetForm} setForm={setTargetForm} />}
        addContent={handleTarget}
        redirect={ROUTES.ALL_TARGETS}
        state={targetForm} setState={setTargetForm}
        // state={targetForm}
        loading={loading}
      />
    </Layout>
  )
}
